/* eslint-disable */
import $ from "jquery";
import "slick-carousel";
import isElement from "../../scripts/util/isElement";

const selectors = {
    reviews: ".js--reviews__slider",
    slider: ".js--retouch__reviews__slider",
    nav: ".js--reviews-slider-nav",
    retouchBaSlider: ".retouch__ba-slider--desktop",
    retouchBaSliderMobile: ".retouch__ba-slider--mobile",
    retouchHowItWorkList: ".retouch__how-it-work--list-wrapper",
};

const time = 750;
const VIEW_MOBILE_SIZE = 1024;
const windowWidth = window.innerWidth;

const reviewsSettings = {
    arrows: false,
    infinite: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: time,
    fade: true,
    adaptiveHeight: false,
    waitForAnimate: false,
    asNavFor: selectors.nav,
};

const reviewsNavSettings = {
    prevArrow:
        '<div class= "reviews-slider__arrow mod--type-left"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="18" viewBox="0 0 33 18" fill="none"><path d="M31.9836 9H1.98358" stroke="#111111" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/><path d="M7.88525 16L1 9L7.88525 2" stroke="#111111" stroke-width="2" stroke-linecap="square" stroke-linejoin="bevel"/></svg></div>',
    nextArrow:
        '<div class= "reviews-slider__arrow mod--type-right"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="18" viewBox="0 0 33 18" fill="none"><path d="M1.01642 9L31.0164 9" stroke="#111111" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/><path d="M25.1148 2L32 9L25.1148 16" stroke="#111111" stroke-width="2" stroke-linecap="square" stroke-linejoin="bevel"/></svg></div>',
    infinite: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: time,
    fade: true,
    adaptiveHeight: false,
    waitForAnimate: false,
    asNavFor: selectors.slider,
    responsive: [
        {
            breakpoint: VIEW_MOBILE_SIZE,
            settings: {
                slidesToShow: 1,
                dots: false,
                touchThreshold: 5,
                swipeToSlide: true,
                waitForAnimate: true,
                cssEase: "ease",
                speed: 500,
                edgeFriction: 0.5,
                adaptiveHeight: true,
            },
        },
    ],
};

const reviewsSlickCarousel = (settings, settingsNav) => {
    const slider = $(selectors.slider);
    const sliderNav = $(selectors.nav);

    slider.slick(settings);
    sliderNav.slick(settingsNav);

    slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        if ($(window).width() > VIEW_MOBILE_SIZE) {
            $(selectors.reviews).addClass("is--disabled");
        }
    });

    sliderNav.on("afterChange", function (event, slick, currentSlide) {
        setTimeout(function () {
            sliderNav.attr("data-slide-active", `slide-active-${currentSlide}`);

            $(selectors.reviews).removeClass("is--disabled");
        }, 100);
    });
};

const toggleRetouchHowItWork = () => {
    let video01;
    let video02;
    let activeVideo;
    let howItWorkBox;
    let prevRatio = 0.0;
    let isEnergySavingMode = false;
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.3,
    };

    const singleRetouchBlock = $(".retouch__how-it-work--list-wrapper--single");
    const multipleRetouchBlock = $(
        ".retouch__how-it-work--list-wrapper--multiple"
    );
    const singleRetouchToggler = $(
        ".retouch__how-it-work--list-toggler-single"
    );
    const multipleRetouchToggler = $(
        ".retouch__how-it-work--list-toggler-multiple"
    );
    const singleRetouchVideo = $(".retouch__how-it-work--video-single");
    const multipleRetouchVideo = $(".retouch__how-it-work--video-multiple");

    let elementHeight = multipleRetouchBlock
        .find(".js--retouch__how-it-work--list-content")
        .height();
    $(".retouch__how-it-work--list-container").css("height", elementHeight);
    multipleRetouchBlock.css("display", "none");

    multipleRetouchToggler.on("click", function () {
        singleRetouchBlock.fadeOut();
        singleRetouchVideo.fadeOut();
        multipleRetouchBlock.fadeIn();
        multipleRetouchVideo.fadeIn();

        activeVideo = video02;
        video01.pause();
        if (!isEnergySavingMode) {
            video01.currentTime = 0;
        }
        video02.play();
    });

    singleRetouchToggler.on("click", function () {
        singleRetouchBlock.fadeIn();
        singleRetouchVideo.fadeIn();
        multipleRetouchBlock.fadeOut();
        multipleRetouchVideo.fadeOut();

        activeVideo = video01;
        video02.pause();
        if (!isEnergySavingMode) {
            video02.currentTime = 0;
        }
        video01.play();
    });

    const checkEnergySavingMode = (video) => {
        video
            .play()
            .then(() => {
                isEnergySavingMode = false;
            })
            .catch(() => {
                isEnergySavingMode = true;
            });
    };

    const videoPlay = (video) => {
        video.play();
    };

    const videoStop = (video) => {
        video.pause();

        if (!isEnergySavingMode) {
            video.currentTime = 0;
        }
    };

    const handleIntersect = (entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > prevRatio) {
                videoPlay(activeVideo);
            } else {
                videoStop(activeVideo);
            }

            prevRatio = entry.intersectionRatio;
        });
    };

    const createObserver = () => {
        let observer;

        observer = new IntersectionObserver(handleIntersect, options); // eslint-disable-line
        observer.observe(howItWorkBox);
    };

    window.addEventListener(
        "load",
        () => {
            howItWorkBox = document.querySelector(".retouch__how-it-work");
            video01 = document.getElementById("retouch-video-single");
            video02 = document.getElementById("retouch-video-multiple");
            activeVideo = video01;
            checkEnergySavingMode(video01);

            createObserver();
        },
        false
    );
};

const render = () => {
    if (isElement(selectors.slider)) {
        reviewsSlickCarousel(reviewsSettings, reviewsNavSettings);
    }

    if (isElement(selectors.retouchHowItWorkList)) {
        toggleRetouchHowItWork();
    }
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/retouch/retouch.js